import errorHandler from 'utils/errorHandler';

import dynamicYieldAPI from './DynamicYieldAPI';

import { EventTypes, PageContextType } from '../consts';
import {
  getProductPropertiesForEvent,
  getCartForEvent,
  calculateOrderDifference,
} from '../utils';

class DynamicYieldService {
  reportPageContext = ({ type, data }) => {
    const recommendationContext = { type };
    if (data && data.length && type !== PageContextType.OTHER) {
      recommendationContext.data = data;
    }

    dynamicYieldAPI.setContext(recommendationContext);
  }

  reportCartEvent = ({ product, quantityDelta, basketItems }) => {
    const quantity = Math.abs(quantityDelta);

    if (product && product.sku) {
      const dyEvent = quantityDelta > 0 ? EventTypes.addToCart : EventTypes.removeFromCart;
      dynamicYieldAPI.reportEvent(dyEvent, {
        ...getProductPropertiesForEvent(product, quantity),
        cart: getCartForEvent(basketItems, product, quantityDelta),
      });
    }
  }

  reportSyncCartEvent = ({ basketItems }) => {
    const eventHandler = dynamicYieldAPI.isApiReady ? 'reportEvent' : 'delayEvent';
    dynamicYieldAPI[eventHandler](EventTypes.syncCart, {
      cart: getCartForEvent(basketItems),
    });
  }

  reportPurchaseEvent = ({ previousOrderEvent: previousOrder, newOrderEvent: newOrder }) => {
    const { orderId, products = [], totalCost } = newOrder;
    if (orderId && products.length) {
      const eventHandler = dynamicYieldAPI.isApiReady ? 'reportEvent' : 'delayEvent';

      // Send "Purchase" and "Custom" events on initial order checkout
      if (!previousOrder) {
        const purchaseDetails = {
          value: totalCost,
          cart: getCartForEvent(products),
        };

        dynamicYieldAPI[eventHandler](EventTypes.purchase, { uniqueTransactionId: orderId, ...purchaseDetails });
        dynamicYieldAPI[eventHandler](EventTypes.addedOnCheckout, purchaseDetails);
      } else {
        const { addedDiff, removedDiff } = calculateOrderDifference(previousOrder, newOrder);

        // Send "Added On Checkout" custom event if products were added
        if (addedDiff) {
          dynamicYieldAPI[eventHandler](EventTypes.addedOnCheckout, addedDiff);
        }

        // Send "Removed from Checkout" custom event if products were removed
        if (removedDiff) {
          dynamicYieldAPI[eventHandler](EventTypes.removedFromCheckout, removedDiff);
        }
      }
    }
  }

  reportLoginEvent = async (customerNum, isJustLoggedInPromise) => {
    if (customerNum) {
      try {
        const isJustLoggedIn = await isJustLoggedInPromise;
        if (isJustLoggedIn) {
          const eventHandler = dynamicYieldAPI.isApiReady ? 'reportEvent' : 'delayEvent';
          dynamicYieldAPI[eventHandler](EventTypes.login, {
            cuid: customerNum,
            cuidType: 'external',
          });
        }
      } catch (e) {
        errorHandler(e);
      }
    }
  }
}

const dynamicYieldService = new DynamicYieldService();

export default dynamicYieldService;
